<template>
    <div :class="classes" v-bind="attributes">
        <div class="google-map" ref="map"></div>
        <slot></slot>
    </div>
</template>

<script>
  import axios from 'axios';
  export default {
    props: {
      classes: {
        type: String,
        default: ''
      },
      attributes: {
        type: Object,
        default: () => ({})
      },
      zoomLevel: {
        type: Number,
        default: 11,
      },
      center: {
        type: Object,
        default: () => ({
          lat: 41.902546,
          lng: 12.495711
        })
      },
      auto: {
        type: Boolean,
        default: false
      },
      initializeOnBoot: {
        type: Boolean,
        default: true
      },
      endpoint: {
        type: String,
        required: false,
      },
      saturation: {
        type: Number,
        default: -100
      },
    },
    data() {
      return {
        markers: [],
        map: Object,
        bounds: Object,
      }
    },
    methods: {
      addMarker(point, description, icon) {
        this.$set(this.markers, this.markers.length, {
          lat: point.lat,
          lng: point.lng,
          description: description,
          icon: icon,
        });
      },
      initializeMap() {
        this.map = new google.maps.Map(this.$refs.map, {
          zoom: this.zoomLevel,
          center: {lat: this.center.lat, lng: this.center.lng},
          styles: [
            {
              "stylers": [ { "saturation": this.saturation }, ]
            },
            {
              "featureType": "administrative",
              "elementType": "all",
              "stylers": [ { "saturation": -100 } ]
            },
            {
              "featureType": "administrative.province",
              "elementType": "labels",
              "stylers": [ { "visibility": "off" } ]
            },
            {
              "featureType": "administrative.land_parcel",
              "elementType": "labels",
              "stylers": [ { "visibility": "off" } ]
            },
            {
              "featureType": "administrative.locality",
              "elementType": "labels",
              "stylers": [ { "visibility": "simplified" } ]
            },
            {
              "featureType": "administrative.neighborhood",
              "elementType": "labels",
              "stylers": [ { "visibility": "off" } ]
            },
            {
              "featureType": "poi",
              "elementType": "labels",
              "stylers": [ { "visibility": "off" } ]
            },
            {
              "featureType": "poi.business",
              "elementType": "labels",
              "stylers": [ { "visibility": "on" } ]
            },
          ],
          mapTypeControl: false,
          rotateControl: false,
          fullscreenControl: false,
          streetViewControl: false,
        });
        this.setupMarkers();
      },
      setupMarkers() {
        //if endpoint is present
        let self = this;
        if(this.endpoint) {
            axios.get(this.endpoint).then(response => {
              if(response.data.length > 0) {
                response.data.forEach(marker => {
                  self.addMarker({
                    lat: marker.coordinates.lat,
                    lng: marker.coordinates.lng,
                  }, marker.description, marker.icon);
                });
                self.addMarkersToMap();
              }
            })
        } else {
          self.addMarkersToMap();
        }
      },
      addMarkersToMap() {
        this.bounds = new google.maps.LatLngBounds();
        let markers = this.markers;

        markers.forEach((marker) => {
          marker.googleInstance = new google.maps.Marker({
            position: {lat: marker.lat, lng: marker.lng},
            map: this.map,
            icon: marker.icon,
          });
          //add info window if marker has embedded description
          if(marker.description) {
            let self = this;
            marker.infoWindow = new google.maps.InfoWindow({
              content: marker.description
            });
            marker.googleInstance.addListener('click', function() {
              self.markers.forEach(m => {
                if(m.infoWindow) {
                  m.infoWindow.close();
                }
              });
              marker.infoWindow.open(self.map, marker.googleInstance);
            });
          }
          this.bounds.extend(new google.maps.LatLng(marker.lat, marker.lng));
        });

        if (this.auto) {
          this.map.fitBounds(this.bounds);
        } else {
          this.map.setCenter({
            lat: this.center.lat,
            lng: this.center.lng,
          });
          this.map.setZoom(this.zoomLevel);
        }
      },
      refreshMarkers(markers) {
        this.markers = [];
        markers.forEach(marker => {
          this.addMarker({
            lat: marker.position.coordinates[1],
            lng: marker.position.coordinates[0],
          }, marker.description, marker.icon);
        });
        this.initializeMap();
        this.setupMarkers();
      },
    },
    created() {
      let self = this;
      this.$root.$on('register-marker', marker => {
        self.addMarker({lat: marker.lat, lng: marker.lng}, marker.description, marker.icon);
      });
      this.$root.$on('rubinred.map.refresh', markers => {
        self.refreshMarkers(markers);
      });
    },
    mounted() {
      window.addEventListener('load', () => {
        if (this.initializeOnBoot) {
          this.initializeMap();
        }
      })
    },
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/cinquanta3/extensions/rubinred/maps/assets/js/components/RubinredMap.vue